import * as React from "react"
import { cn } from "@/lib/utils"

export interface PopoverProps {
  trigger: React.ReactNode
  content: React.ReactNode
  className?: string
}

export function Popover({ trigger, content, className }: PopoverProps){
  const [open,setOpen]=React.useState(false)
  const ref = React.useRef<HTMLDivElement>(null)
  React.useEffect(()=>{
    const onDoc=(e:MouseEvent)=>{ if(ref.current && !ref.current.contains(e.target as Node)) setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    return ()=> document.removeEventListener('mousedown', onDoc)
  },[])
  return (
    <div className="relative inline-block" ref={ref}>
      <span onClick={()=>setOpen(v=>!v)} className="inline-block">{trigger}</span>
      {open && (
        <div className={cn("absolute z-50 mt-2 min-w-40 rounded-md border border-border bg-popover p-2 text-popover-foreground shadow", className)}>
          {content}
        </div>
      )}
    </div>
  )
}
